class PrzyziemniShareButton extends HTMLElement {
  connectedCallback() {
    if (this.dataset.shareBound === 'true') return;

    this.dataset.shareBound = 'true';
    this.button = this.querySelector('[data-share-trigger]');
    this.panel = this.querySelector('[data-share-panel]');
    this.status = this.querySelector('[data-share-status]');
    this.copyButton = this.querySelector('[data-share-copy]');
    this.moreButton = this.querySelector('[data-share-more]');
    this.closeButton = this.querySelector('[data-share-close]');

    if (!this.button || !this.panel) return;

    this.setShareLinks();

    this.button.addEventListener('click', (event) => {
      event.stopPropagation();
      this.togglePanel();
    });

    this.panel.addEventListener('click', (event) => event.stopPropagation());
    this.closeButton?.addEventListener('click', () => this.closePanel());
    this.copyButton?.addEventListener('click', () => this.copyLink());
    this.moreButton?.addEventListener('click', () => this.nativeShare());

    this.querySelectorAll('[data-share-service]').forEach((link) => {
      link.addEventListener('click', () => this.closePanel());
    });

    this.handleDocumentClick = () => this.closePanel();
    this.handleKeydown = (event) => {
      if (event.key === 'Escape') {
        this.closePanel();
        this.button.focus();
      }
    };

    document.addEventListener('click', this.handleDocumentClick);
    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('keydown', this.handleKeydown);
  }

  getShareData() {
    const canonical = document.querySelector('link[rel="canonical"]');
    const url = canonical?.href || window.location.href;
    const title = this.dataset.shareTitle || document.title;
    const image =
      document.querySelector('meta[property="og:image:secure_url"]')?.content ||
      document.querySelector('meta[property="og:image"]')?.content ||
      '';

    return { url, title, image };
  }

  setShareLinks() {
    const { url, title, image } = this.getShareData();
    const encodedUrl = encodeURIComponent(url);
    const encodedTitle = encodeURIComponent(title);
    const encodedMessage = encodeURIComponent(title + '\n' + url);

    const facebook = this.querySelector('[data-share-service="facebook"]');
    const whatsapp = this.querySelector('[data-share-service="whatsapp"]');
    const x = this.querySelector('[data-share-service="x"]');
    const pinterest = this.querySelector('[data-share-service="pinterest"]');

    if (facebook) {
      facebook.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl;
    }
    if (whatsapp) {
      whatsapp.href = 'https://wa.me/?text=' + encodedMessage;
    }
    if (x) {
      x.href = 'https://twitter.com/intent/tweet?text=' + encodedTitle + '&url=' + encodedUrl;
    }
    if (pinterest && image) {
      pinterest.href =
        'https://www.pinterest.com/pin/create/button/?url=' +
        encodedUrl +
        '&media=' +
        encodeURIComponent(image) +
        '&description=' +
        encodedTitle;
    } else if (pinterest) {
      pinterest.hidden = true;
    }
  }

  togglePanel() {
    if (this.panel.hidden) {
      this.openPanel();
    } else {
      this.closePanel();
    }
  }

  openPanel() {
    this.panel.hidden = false;
    this.button.setAttribute('aria-expanded', 'true');
    this.closeButton?.focus();
  }

  closePanel() {
    if (!this.panel) return;
    this.panel.hidden = true;
    this.button?.setAttribute('aria-expanded', 'false');
  }

  async nativeShare() {
    const { url, title } = this.getShareData();

    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        this.closePanel();
        return;
      } catch (error) {
        if (error?.name === 'AbortError') return;
      }
    }

    await this.copyLink();
  }

  async copyLink() {
    const { url } = this.getShareData();

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const input = document.createElement('textarea');
        input.value = url;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }

      this.closePanel();
      this.showStatus('Link skopiowany');
    } catch (error) {
      this.closePanel();
      this.showStatus('Nie udało się skopiować linku');
    }
  }

  showStatus(message) {
    if (!this.status) return;

    this.status.textContent = message;
    window.clearTimeout(this.statusTimer);
    this.statusTimer = window.setTimeout(() => {
      this.status.textContent = '';
    }, 2400);
  }
}

if (!customElements.get('przyziemni-share-button')) {
  customElements.define('przyziemni-share-button', PrzyziemniShareButton);
}
